import { render, staticRenderFns } from "./SolicitudNuevoPersonal.vue?vue&type=template&id=5a572480"
import script from "./SolicitudNuevoPersonal.vue?vue&type=script&lang=js"
export * from "./SolicitudNuevoPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports